import React, { useEffect, useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import AnimateHeight from 'react-animate-height';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Expander = _ref => {
  let {
    title,
    close,
    children
  } = _ref;
  const {
    0: height,
    1: setHeight
  } = useState(0);
  useEffect(() => {
    if (close) {
      setHeight(0);
    }
  }, [close]);
  const toggle = () => {
    setHeight(height === 0 ? 'auto' : 0);
  };
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("button", {
    className: "int-expander-toggler",
    onClick: toggle
  }, title, " ", height !== 0 ? ___EmotionJSX(FaChevronUp, null) : ___EmotionJSX(FaChevronDown, null)), ___EmotionJSX(AnimateHeight, {
    duration: 500,
    height: height
  }, children));
};
export default Expander;